<template>
  <footer class="mt-10 flex shrink-0 flex-col items-center gap-2 border-t border-grey-200 pt-4.5 text-center dark:border-hairline">
    <div class="font-body text-xs text-grey-400">{{ t('footer.tagline') }} · v{{ version }} · © {{ year }} Invoxia</div>
    <nav class="flex flex-wrap items-center justify-center gap-4.5">
      <a
        href="https://www.invoxia.com/legal/services/general"
        target="_blank"
        rel="noopener"
        class="font-body text-xs text-faint no-underline transition-colors hover:text-invoxia-blue"
        >{{ t('footer.terms') }}</a
      >
      <a
        href="https://www.invoxia.com/legal/site/privacy"
        target="_blank"
        rel="noopener"
        class="font-body text-xs text-faint no-underline transition-colors hover:text-invoxia-blue"
        >{{ t('footer.privacy') }}</a
      >
      <a
        href="https://www.invoxia.com/chatbot"
        target="_blank"
        rel="noopener"
        class="font-body text-xs text-faint no-underline transition-colors hover:text-invoxia-blue"
        >{{ t('footer.support') }}</a
      >
    </nav>
  </footer>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { homeMessages } from '@/lang/pages/home'

const { t } = useI18n({ useScope: 'local', messages: homeMessages, inheritLocale: true })

const year = new Date().getFullYear()
const version = window._env_?.ITP_VERSION ?? ''
</script>
